module.exports = __webpack_public_path__ + "img/imgRemove03.e5b995ce.png";